/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

window._      =require('lodash');
window.moment =require('moment');
Vue.prototype._ = require('lodash');
// Vuesax Component Framework
import Vuesax from 'vuesax'

import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)

// require('dotenv').config({ debug: process.env.DEBUG })

window.axios = require('axios');

// INSTANCIA DE AUTHORIZATION
if(!_.isEmpty(localStorage.getItem("accessToken"))){
    const accesToken  = localStorage.getItem("accessToken");
    window.axios.defaults.headers.common['Authorization'] = (accesToken);
}

// FIN DE INSTANCIA DE AUTHORIZATION

Vue.prototype.$http = window.axios

// API Calls
import "./http/requests"

// mock
import "./fake-db/index.js"

// Theme Configurations
import '../themeConfig.js'


// Firebase
import '@/firebase/firebaseConfig'


// Auth0 Plugin
import AuthPlugin from "./plugins/auth";
Vue.use(AuthPlugin);


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import validator_es from 'vee-validate/dist/locale/es';
import VeeValidate , { Validator } from 'vee-validate'
Vue.use(VeeValidate);
Validator.localize('es', validator_es);

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: 'YOUR_API_KEY',
        libraries: 'places', // This is required if you use the Auto complete plug-in
    },
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Vue.use(VueGoogleMaps)

// Feather font icon
require('./assets/css/iconfont.css')

// import dotenv from 'dotenv'
// console.log(dotenv);
// dotenv.config()

// console.log(process.env)


Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    acl,
    render: h => h(App)
}).$mount('#app')
